const initialState = {
  datacollectionurl: ''
  };
  
  const dataCollectionurlReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_DATA_COLLECTION_URL':
            return { ...state, datacollectionurl: action.payload };
        default:
            return state;
    }
  };
  
  export default dataCollectionurlReducer;
  